import { IPresenterOwner, Logger, Presenter } from 'wdc-cube'
import { EMPTY_EXPORT_DOCUMENTS, ExportDocumentsResponse, ExportDocumentsScope } from './export_documents_scope'

const LOG = Logger.get('ExportDocumentsPresenter')

const DEFAULT_LIMIT = 10

export type ExportDocumentsFetcher = (
    exportId: number,
    query: { page: number; limit: number }
) => Promise<ExportDocumentsResponse>

export class ExportDocumentsPresenter extends Presenter<ExportDocumentsScope, IPresenterOwner> {
    private __fetcher?: ExportDocumentsFetcher
    private __exportId?: number

    constructor(owner: IPresenterOwner, scope: ExportDocumentsScope) {
        super(owner, scope)
    }

    initialize(fetcher: ExportDocumentsFetcher) {
        this.__fetcher = fetcher
        this.scope.onChangePage = this.action(this.__onChangePage)
        this.scope.onChangeRowsPerPage = this.action(this.__onChangeRowsPerPage)
        this.scope.onClose = this.action(this.__onClose)
    }

    async open(exportId: number) {
        this.__exportId = exportId
        this.scope.page = 0
        this.scope.limit = DEFAULT_LIMIT
        this.scope.data = EMPTY_EXPORT_DOCUMENTS
        this.scope.open = true
        await this.__reload()
    }

    async __onChangePage(page: number) {
        this.scope.page = page
        await this.__reload()
    }

    async __onChangeRowsPerPage(limit: number) {
        this.scope.limit = limit
        this.scope.page = 0
        await this.__reload()
    }

    async __onClose() {
        this.scope.open = false
        this.__exportId = undefined
        this.scope.data = EMPTY_EXPORT_DOCUMENTS
    }

    private async __reload() {
        if (this.__exportId === undefined || !this.__fetcher) {
            return
        }
        try {
            this.scope.loading = true
            this.scope.data = await this.__fetcher(this.__exportId, {
                page: this.scope.page,
                limit: this.scope.limit
            })
        } catch (caught) {
            LOG.error('reload', caught)
        } finally {
            this.scope.loading = false
        }
    }
}
